<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <total-graphic
            graphic-id="totalGraphic"
            url="notification_schedules/total_metrics"
            :filters="filters"
            :response-keys="responseKeys"
            :labels="labels">
          </total-graphic>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import TotalGraphic from '@/components/global/TotalGraphic';
import formatDateMixin from '@/mixins/formatDate';
import EventBus from '@/event-bus';

export default {
  components: {
    TotalGraphic,
  },
  mixins: [
    formatDateMixin,
  ],
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  created() {
    EventBus.$on('totalGraphicSeries', (series) => {
      this.series = series;
    });
  },
  destroyed() {
    EventBus.$off('totalGraphicSeries');
  },
  data() {
    return {
      series: [],
      labels: [
        'Email',
        'Sms',
        'Ivr',
        'Bot',
        'Call - Discador',
        'Call - Individual',
      ],
      responseKeys: {
        number: 'sended',
        delivered: 'delivered',
        payed: 'payed',
      },
    };
  },
  methods: {
    generateReport() {
      EventBus.$emit('startListenEvent');
      const data = {
        filters: { ...this.filters },
        functionName: 'managementTotal',
      };
      this.axios.post('/reports', data).then(() => {
        EventBus.$emit('infoModal',
          'Se esta generando su archivo, se le informara cuando este listo el reporte, por favor espere.',
          'fas fa-check-double');
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/panel/management/Total.vue